<template>
  <div class="mainer">
   
<div>
    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
     病区选择
    </van-divider>
    <van-grid :column-num="1" :gutter="10">
      <!-- <van-grid-item icon="./image/drgh.png" text="当日挂号" to="/Office?ghlx=1" /> -->
      <!-- <van-grid-item icon="./image/yygh.png" text="预约挂号" to="/Office?ghlx=2" /> -->
      <van-grid-item  class="my-grid-item" icon="./image/yygh.png" text="县城院区(综合科门诊及住院部):陵江镇嘉陵路西段266号" :to=data.addr1 />
      <van-grid-item class="my-grid-item"  icon="./image/yygh.png" text="回水院区(精神科住院部及门诊):回水社区四组" :to=data.addr2 />
      <!-- <van-grid-item class="my-grid-item"  icon="./image/yygh.png" text="江南院区(精神心理门诊):江南镇少屏路263号" :to=data.addr3 /> -->
      <van-grid-item class="my-grid-item" icon="./image/yygh.png" text="返回上级" @click="onClickLeft" />
    </van-grid>


  </div>

  

  
  </div>
</template>

<script setup>

import { onMounted, ref } from 'vue'
import { postJson,postJson_async } from '@/api/axiosInstance'
import {  showFailToast, GridProps, GridDirection, GridItemProps} from 'vant';
import router from '@/router'
import { useopenidStore } from '@/stores'
import imgUrl from '@/assets/guide/notice.png'



var data = ref({
  ghlx: 0,
  bq:1,
  addr1:'',
  addr2:'',
  addr3:''
}
)





onMounted(() => {
  data.value.openidstroe = useopenidStore()
  data.value.openid = useopenidStore().data.openid;
  if (!data.value.openid) {
    showFailToast('未获取到openid');
    // history.back();
  }

  
  data.value.ghlx = router.currentRoute.value.query.ghlx;

  console.log('挂号类型' + data.value.ghlx);
  data.value.openid = data.value.openidstroe.data.openid
  console.log('微信data.value.openidstroe.openid：' + data.value.openid);
 data.value.addr1="/Office?ghlx="+data.value.ghlx+"&bq=1"
 data.value.addr2="/Office?ghlx="+data.value.ghlx+"&bq=2"
 data.value.addr3="/Office?ghlx="+data.value.ghlx+"&bq=3"

}
)





function onClickLeft() {
  history.back();
}




</script>

<style scoped lang="less">
.van-nav-bar {
  background: #1989fa;

  /deep/ .van-nav-bar__title {
    color: white;
  }

  /deep/ .van-icon {
    color: white;
  }

  /deep/ .van-nav-bar__right {
    color: white;
  }

  /deep/ .van-nav-bar__left {
    color: white;
  }
}

.byxx {
  background-color: #888;
}

.office {
  width: 100%;
}
.my-grid-item {
height: 100px;
}
</style>